import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link, NavLink } from 'react-router-dom';

const MenuLineButton = (props) => {
    const [showArrow, setShowArrow] =useState(false);


    useEffect(() => {
      if(props.isArrow == props.link){
        setShowArrow(true);
      }else{
        setShowArrow(false)
      }
    }, [props.isArrow]);

    const newLocationHandler = () =>{
        props.showArrow(props.link);
        props.setExpandedManuItem();
    }

    return <>
 <li key={props.keyId} className="dashboard__submenu-item">
            <NavLink
                className={showArrow?"dashboard__submenu-link dashboard-link dashboard-link-active colorEDS":"colorEDS dashboard__submenu-link dashboard-link"}
                to={props.link}
            >
                 <svg
                    className="dashboard__btn-arrow"
                    viewBox="0 0 24 11"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    fill="#CC0033"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                    />
                </svg>
                <span className="dashboard__submenu-title" onClick={newLocationHandler}> {props.tittle}</span>
          
            </NavLink>
        </li>


</>;
};

export default MenuLineButton;
